import { useContext, useEffect, useState } from "react";
import "./search-page.css";
import { cartContext } from "../../App";
import ProductInfoCard from "../ui/productInfoCard";
import { useNavigate } from "react-router-dom";
import AiOrb from "../subcomponents/aiOrb/AiOrb";

export default function SearchPage() {
    const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
    const AUTH_TOKEN = process.env.REACT_APP_AUTH_TOKEN;

    const { productDataList, maxAmountReached } = useContext(cartContext);
    const [searchTerms, setSearchTerms] = useState("");
    const [searchItems, setSearchItems] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const [recentSearches, setRecentSearches] = useState([]);

    useEffect(() => {
        const history =
            JSON.parse(localStorage.getItem("recentSearches")) || [];

        setRecentSearches(history);
    }, []);

    function back() {
        navigate(-1);
    }

    function clear() {
        setSearchTerms("");
    }

    function handleKeyDown(e) {
        if (e.key !== "Enter") return;

        e.target.blur();

        const query = searchTerms.trim();

        if (!query) return;

        setSearchItems(query);

        let history = JSON.parse(localStorage.getItem("recentSearches")) || [];

        history = history.filter((item) => item !== query);

        history.unshift(query);

        history = history.slice(0, 6);

        localStorage.setItem("recentSearches", JSON.stringify(history));

        setRecentSearches(history);

        setLoading(true);

        fetch(`${BACKEND_URL}/search-items`, {
            method: "POST",

            headers: {
                Authorization: `Bearer ${AUTH_TOKEN}`,

                "content-type": "application/json",
            },

            body: JSON.stringify({
                searchItems: query,
            }),
        })
            .then((res) => res.json())
            .then((data) => {
                console.log(data);
            })
            .catch(console.error)
            .finally(() => {
                setLoading(false);
            });
    }

    const filteredData =
        searchTerms.length > 1
            ? productDataList
                  .map((data) => {
                      const title = data.data.title.toLowerCase();
                      const desc = data.data.description.toLowerCase();
                      const terms = searchTerms.toLowerCase().split(/\s+/);

                      // Calculate the number of matched characters
                      const matchCount = terms.reduce((count, char) => {
                          return (
                              count +
                              (title.includes(char) ? 1 : 0) +
                              (desc.includes(char) ? 1 : 0)
                          );
                      }, 0);

                      return { ...data, matchCount }; // Add matchCount to the object
                  })
                  .filter((data) => data.matchCount > 0) // Filter out items with no matches
                  .sort((a, b) => b.matchCount - a.matchCount) // Sort by matchCount in descending order
            : [];

    return (
        <div className="search-page-box">
            <div className="search-page-header">
                <button className="search-page-back-btn" onClick={back}>
                    <img src="/icons/left-arrow.png" alt="back" />
                </button>

                <div className="search-page-search-wrapper">
                    <img
                        src="/find.png"
                        alt="search"
                        className="search-page-search-icon"
                    />

                    <input
                        type="text"
                        value={searchTerms}
                        autoFocus
                        placeholder="Search groceries or ask AI..."
                        className="search-page-bar"
                        onChange={(e) => setSearchTerms(e.target.value)}
                        onKeyDown={handleKeyDown}
                    />

                    {searchTerms && (
                        <img
                            src="/icons/x-mark.png"
                            alt="clear"
                            className="search-page-clear"
                            onClick={clear}
                        />
                    )}

                    <AiOrb variant="compact" onClick={() => navigate("/ai-assistant")} />
                </div>
            </div>
            {searchTerms.length === 0 && recentSearches.length > 0 && (
                <>
                    <p className="search-page-title">Recent Searches</p>

                    <div className="search-page-chip-container">
                        {recentSearches.map((item) => (
                            <button
                                key={item}
                                className="search-page-chip"
                                onClick={() => {
                                    setSearchTerms(item);

                                    setSearchItems(item);
                                }}
                            >
                                🕘 {item}
                            </button>
                        ))}
                    </div>
                </>
            )}
            {searchTerms.length === 0 && (
                <div className="search-page-trending">
                    <p className="search-page-title">🔥 Trending</p>

                    <div className="search-page-chip-container">
                        {[
                            "Milk",

                            "Tomato",

                            "Egg",

                            "Rice",

                            "Banana",

                            "Potato",

                            "Chicken",

                            "Cooking Oil",
                        ].map((item) => (
                            <button
                                key={item}
                                className="search-page-chip"
                                onClick={() => {
                                    setSearchTerms(item);

                                    setSearchItems(item);
                                }}
                            >
                                {item}
                            </button>
                        ))}
                    </div>
                </div>
            )}
            {loading && (
                <div className="search-page-loading">
                    {[...Array(6)].map((_, index) => (
                        <div key={index} className="search-page-skeleton" />
                    ))}
                </div>
            )}
            {filteredData.length > 0 ? (
                <>
                    {maxAmountReached && (
                        <div className="max-amount-reached">
                            <p className="max-amount-reached-text">
                                Maximum Quantity Reached!
                            </p>
                        </div>
                    )}
                    <div className="search-page-result-header">
                        <h3>Results</h3>

                        <p>
                            for <strong>{searchTerms}</strong>
                        </p>
                    </div>
                    <div className="search-page-products">
                        <ProductInfoCard dataList={filteredData} />
                    </div>
                </>
            ) : searchItems.length > 1 ? (
                <div className="search-page-list-container">
                    <div className="search-page-empty">
                        <img
                            src="/icons/search.png"
                            alt="empty"
                            className="search-page-empty-image"
                        />

                        <h3>Couldn't find</h3>

                        <p>"{searchTerms}"</p>

                        <button
                            className="search-page-ai-btn"
                            onClick={() => navigate("/ai-assistant")}
                        >
                            ✨ Ask Freslo AI
                        </button>
                    </div>
                </div>
            ) : (
                <div className="search-page-list-container"></div>
            )}
        </div>
    );
}
